import React, { useEffect, useState, useRef } from 'react';
import { testAPI, useTypes } from '../../hooks/useSupportingArticle';
import authApi from '../../apis/authApi';
import axios from 'axios';

import { Modal, Form, Select, Button, Input, Upload, Checkbox, Tag, Space, notification, Spin } from 'antd';
import useStudios, { fetchAllStudios, useListingStudios } from '../../hooks/useStudios';
import { GetImageUploadURL, PostSupportingArticle, useGenerateFxCodes } from '../../hooks/useCreation';
import { useCompanies, useListingCompanies } from '../../hooks/useCompanies';
import useLogout from '../../hooks/useLogout';
import { useQuery } from 'react-query';
import { v4 as uuidv4 } from 'uuid';
import arrowLeft from '../../../src/assets/images/arrowLeft.png';
import { useNavigate } from 'react-router-dom';
import { CheckCircleOutlined, DeleteOutlined, StopOutlined } from '@ant-design/icons';
import forKids from '../../../src/assets/images/gender_kids.png';
import forFemales from '../../../src/assets/images/gender_female.png';
import forMales from '../../../src/assets/images/gender_male.png';
import forUnisex from '../../../src/assets/images/gender_unisex.png';

const productTags = {
    Gender: '',
    Size: '',
    Color: '',
};

const CreationModal = () => {
    const [openModal, setOpen] = useState(true);
    const [imageLoading, setImageLoading] = useState(false);
    const [imageStatus, setImageStatus] = useState({ error: false, initiatedUpload: false });
    const [reqBody, setReqBody] = useState({});
    const [tags, setTags] = useState([]);
    const [showPurchase, setShowPurchase] = useState(false);
    const { logout } = useLogout();
    const [api, contextHolder] = notification.useNotification();

    const [keyValueTags, setKeyValueTags] = useState([
        {
            id: uuidv4(),
            key: 'Size',
            value: '',
        },
        {
            id: uuidv4(),
            key: 'Color',
            value: '',
        },
        {
            id: uuidv4(),
            key: 'Gender',
            value: '',
        },
    ]);

    const navigate = useNavigate();
    const onSuccess = data => {};
    const onError = () => {};
    let pageNumber = 1;
    let pageSize = 10;
    // const {
    //   data: studios,
    //   isError,

    //   refetch: fetchAllStudioData,
    // } = useQuery(["listing", pageNumber, pageSize], fetchAllStudios);
    // const { data: studios, isError } = useStudios(onSuccess);
    const { data: allCompanies } = useListingCompanies(onSuccess);
    const { data: studioList, isError } = useListingStudios(onSuccess);
    const { mutate: generateCodes } = useGenerateFxCodes(onSuccessFx, onErrorFx);
    const { data: allTypes } = useTypes();
    const inputRef = useRef(null);
    const [presetStudioName, setPresetStudioName] = useState('');

    // useEffect(() => {
    //   fetchAllStudioData();
    // }, []);

    function onSuccessFx(resp) {
        console.log('onSuccessFx: ', resp);
        let tempDataObj = { ...reqBody };
        tempDataObj['fxCode'] = resp?.data?.id;
        setReqBody({ ...tempDataObj });
    }
    function onErrorFx(err) {
        console.log(err);
        notification.error({
            message: 'Error',
            description: err?.response?.data?.message,
        });
        if (err?.response?.status === 401) logout();
    }

    const handleClose = removedTag => {
        const newTags = tags.filter(tag => tag !== removedTag);
        setTags(newTags);
    };

    const addTags = tag => {
        if (tag) setTags([...tags, tag]);
        inputRef.current.input.value = ' ';
    };

    const getFileExtension = file => {
        var fileName = file.name;
        return fileName.split('.').pop();
    };

    const handleUpload = async file => {
        setImageStatus({ ...imageStatus, initiatedUpload: true });
        setImageLoading(true);
        const reqDataObj = {};
        reqDataObj.mimeType = file.type;
        reqDataObj.fileExtension = getFileExtension(file);
        reqDataObj.studioName = presetStudioName;
        authApi
            .getImageUrl(reqDataObj)
            .then(resp => {
                axios
                    .put(`${resp.data.url}`, file)
                    .then(res => {
                        setImageStatus({ initiatedUpload: true, error: false });
                        reqBody.image = { imagePath: { key: resp.data.key } };
                        setReqBody({ ...reqBody });
                        setImageLoading(false);
                    })
                    .catch(err => {
                        if (err?.response?.status === 401) logout();
                    });
            })
            .catch(err => {
                setImageStatus({ initiatedUpload: true, error: true });
                setImageLoading(false);
                if (reqBody?.image) {
                    let newReqBody = reqBody;
                    delete newReqBody.image;
                    setReqBody(newReqBody);
                }
                if (err?.response?.status === 401) logout();
            });
    };

    const handleChange = (key, value) => {
        let tempDataObj = { ...reqBody };
        if (value) tempDataObj[key] = value;
        else delete tempDataObj[key];
        setReqBody({ ...tempDataObj });
    };
    const handleSubmit = () => {
        const bodyObj = reqBody;
        bodyObj.keywords = tags;
        bodyObj['productTags'] = getkeyValueTags();
        if (bodyObj.purchaseStatus && !bodyObj.purchaseStatus.requested) delete bodyObj.purchaseStatus;
        console.log('bodyObj::: ', bodyObj);
        PostSupportingArticle(bodyObj)
            .then(() => {
                api.success({
                    message: 'Great!',
                    description: 'Supporting Artical Created Successfully!',
                    placement: 'topRight',
                });
            })
            .catch(err => {
                api.error({
                    message: 'Ooops!',
                    description: 'Supporting Article could not be created!',
                    placement: 'topRight',
                });
                if (err?.response?.status === 401) logout();
            });
    };
    const handleNestedReqBody = (key, value, parentKey) => {
        let tempDataObj = { ...reqBody };
        if (!tempDataObj[parentKey]) tempDataObj[parentKey] = {};
        if (value) tempDataObj[parentKey][key] = value;
        else delete tempDataObj[parentKey][key];
        setReqBody({ ...tempDataObj });
    };

    const getkeyValueTags = () => {
        let items = [...keyValueTags];
        let returnableItem = {};
        items.forEach(item => {
            returnableItem[item?.key] = item?.value;
        });
        return returnableItem;
    };

    if (isError) {
        logout();
    }
    const handleRemoveProductTag = id => {
        let items = [...keyValueTags];
        let filteredItems = items?.filter(item => item?.id !== id);
        setKeyValueTags(filteredItems);
    };
    const handleKeyValueChange = (e, item, tag) => {
        let val = e?.target?.value;
        if (item?.key === 'Gender') {
            val = e;
        }
        let items = [...keyValueTags];
        let indexOfItem = items?.findIndex(elm => elm?.id === item?.id);

        if (tag === 'tagName') {
            items[indexOfItem] = { ...item, key: val };
        } else if (tag === 'tagValue') {
            items[indexOfItem] = { ...item, value: val };
        }
        setKeyValueTags([...items]);
    };
    const checkForProductTags = () => {
        let items = [...keyValueTags];
        let filteredItem = items.filter(item => ['size', 'gender', 'color'].includes(item?.key.toLowerCase()));
        let disabled = false;
        for (let item of filteredItem) {
            if (item?.value === '') {
                disabled = true;
            }
        }
        for (let item of items) {
            if (item?.key === '' || item?.value === '') {
                disabled = true;
            }
        }
        return disabled;
    };
    const getGenderOptions = () => {
        let retrunableOptions = [
            {
                label: (
                    <div>
                        <img src={forMales} alt="gender_man" style={{ width: '13px', height: '13px', marginRight: '5px' }} />
                        Male
                    </div>
                ),
                value: 'Male',
            },
            {
                label: (
                    <div>
                        <img src={forFemales} alt="gender_woman" style={{ width: '13px', height: '13px', marginRight: '5px' }} />
                        Female
                    </div>
                ),
                value: 'Female',
            },
            {
                label: (
                    <div>
                        <img src={forUnisex} alt="gender_unisex" style={{ width: '13px', height: '13px', marginRight: '5px' }} />
                        Unisex
                    </div>
                ),
                value: 'Unisex',
            },
            {
                label: (
                    <div>
                        <img src={forKids} alt="gender_kids" style={{ width: '13px', height: '13px', marginRight: '5px' }} />
                        Kids
                    </div>
                ),
                value: 'Kids',
            },
        ];
        return retrunableOptions;
    };
    return (
        <>
            <img
                src={arrowLeft}
                alt=""
                style={{
                    width: '30px',
                    cursor: 'pointer',
                    margin: '5px',
                    // padding: "10px",
                }}
                onClick={() => navigate(-1)}
            />

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {contextHolder}
                <Form
                    wrapperCol={{
                        span: 15,
                    }}
                    layout="horizontal"
                    style={{
                        maxWidth: 800,
                        border: '1px solid grey',
                        padding: '20px',
                        borderRadius: '10px',
                    }}
                >
                    <h3>Supporting Article Creation</h3>
                    <Form.Item label="Studio">
                        <Select
                            onChange={(value, obj) => {
                                setPresetStudioName(obj.children);
                                handleChange('studioId', value);
                            }}
                        >
                            {studioList?.map(studio => (
                                <Select.Option key={studio._id} value={studio._id}>
                                    {studio.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Image*">
                        <Space>
                            <input disabled={!reqBody.studioId} type="file" onChange={e => handleUpload(e.target.files[0])} />
                            {imageLoading ? <Spin /> : null}
                            {imageStatus?.initiatedUpload && !imageLoading ? (
                                <div>
                                    {!imageStatus?.error ? (
                                        <div style={{ color: 'green', width: 'max-content' }}>
                                            {' '}
                                            <CheckCircleOutlined style={{ marginRight: '5px' }} />
                                            Image upload successful
                                        </div>
                                    ) : (
                                        <div style={{ color: 'red', width: 'max-content' }}>Image could not be uploaded. Please retry.</div>
                                    )}
                                </div>
                            ) : null}
                        </Space>
                    </Form.Item>

                    <Form.Item label="Fx Code">
                        <Space direction="horizontal">
                            <Input
                                placeholder="Add FX Code"
                                enterButton="Add"
                                size="large"
                                value={reqBody?.fxCode}
                                onChange={e => {
                                    handleChange('fxCode', e?.target?.value);
                                }}
                            />
                            <Button onClick={() => generateCodes()} style={{ width: 120 }}>
                                Generate Code
                            </Button>
                        </Space>
                    </Form.Item>

                    <Form.Item label="Type*">
                        <Select
                            onChange={value => {
                                handleChange('type', value);
                            }}
                        >
                            {allTypes?.map(type => (
                                <Select.Option key={type} value={type}>
                                    {type}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Keywords">
                        <Space direction="horizontal">
                            <Input
                                placeholder="Add Tags*"
                                allowClear
                                // enterButton="Add"
                                size="large"
                                ref={inputRef}
                            />
                            <Button style={{ width: 80 }} onClick={e => addTags(inputRef.current.input.value.trim())}>
                                Add
                            </Button>
                        </Space>
                        {tags.map((tag, i) => (
                            <Tag
                                key={`${tag}${i}`}
                                closable
                                onClose={e => {
                                    e.preventDefault();
                                    handleClose(tag);
                                }}
                                style={{ margin: '5px' }}
                            >
                                {tag}
                            </Tag>
                        ))}
                    </Form.Item>

                    <Form.Item label="Product Tags*">
                        <Space direction="horizontal" align="start">
                            <Space direction="vertical">
                                {keyValueTags.map((item, index) => {
                                    return (
                                        <Space direction="horizontal" key={index}>
                                            <Input
                                                placeholder="Tag name"
                                                allowClear
                                                enterButton="Add"
                                                size="large"
                                                value={item?.key}
                                                onChange={e => handleKeyValueChange(e, item, 'tagName')}
                                                disabled={['size', 'gender', 'color'].includes(item?.key.toLowerCase())}
                                            />
                                            {item?.key === 'Gender' ? (
                                                <Select
                                                    value={item?.value || null}
                                                    enterButton="Add"
                                                    size="large"
                                                    onChange={e => handleKeyValueChange(e, item, 'tagValue')}
                                                    options={getGenderOptions()}
                                                    style={{
                                                        width: '8.8rem',
                                                    }}
                                                    placeholder="Tag value"
                                                />
                                            ) : (
                                                <Input
                                                    placeholder="Tag value"
                                                    allowClear
                                                    enterButton="Add"
                                                    size="large"
                                                    value={item?.value}
                                                    onChange={e => handleKeyValueChange(e, item, 'tagValue')}
                                                />
                                            )}
                                            {['size', 'gender', 'color'].includes(item?.key.toLowerCase()) ? (
                                                <Button
                                                    type="text"
                                                    style={{
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                    disabled
                                                >
                                                    <DeleteOutlined />
                                                </Button>
                                            ) : (
                                                <Button
                                                    type="text"
                                                    style={{
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                    onClick={() => handleRemoveProductTag(item?.id)}
                                                >
                                                    <DeleteOutlined />
                                                </Button>
                                            )}
                                        </Space>
                                    );
                                })}
                            </Space>
                            <Space direction="vertical" align="start">
                                <Button
                                    style={{ width: 100 }}
                                    onClick={e =>
                                        setKeyValueTags(prev => [
                                            ...prev,
                                            {
                                                id: uuidv4(),
                                                key: '',
                                                value: '',
                                            },
                                        ])
                                    }
                                >
                                    + Add more
                                </Button>
                            </Space>
                        </Space>
                    </Form.Item>
                    <Form.Item label="Ownership">
                        <Select
                            onChange={value => {
                                handleChange('ownership', value);
                            }}
                        >
                            <Select.Option key="default" value={null}>
                                Not Applicable
                            </Select.Option>
                            {allCompanies?.map(company => (
                                <Select.Option key={company._id} value={company._id}>
                                    {company.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="" valuePropName="checked">
                        <Checkbox onChange={({ target }) => handleNestedReqBody('requested', target.checked, 'purchaseStatus')}>
                            Raise a purchase request?
                        </Checkbox>
                    </Form.Item>

                    {reqBody.purchaseStatus?.requested && (
                        <>
                            <Form.Item label="Product URL">
                                <Input
                                    onChange={({ target }) => {
                                        handleNestedReqBody('productUrl', target.value, 'purchaseStatus');
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Instructions">
                                <Input.TextArea
                                    showCount
                                    maxLength={100}
                                    //   style={{ height: 120, resize: "none" }}
                                    onChange={({ target }) => {
                                        handleNestedReqBody('comment', target.value, 'purchaseStatus');
                                    }}
                                    placeholder="Instructions"
                                />
                            </Form.Item>
                        </>
                    )}
                    <Form.Item label="">
                        <Button onClick={handleSubmit} disabled={!(reqBody.studioId && reqBody.image && reqBody.type) || checkForProductTags()}>
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    );
};

export default CreationModal;
